/** Gets the search text from a query */
export const getSearchQueryText = (query?: string) => query?.split(':')[0] ?? ''

export const getSearchQueryPart = (query: string, key?: string): string | null => {
  if (query === undefined || query === null || query === '') {
    return null
  }
  if (!key) {
    return query
  }
  const parts = query.split(':')
  for (let i = 0; i < parts.length; i++) {
    if (parts[i] === key && i + 1 < parts.length) {
      return parts[i + 1]
    }
  }

  return query
}
